import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ allocation, nextAllocation }) => {
    return present(
      repository
        .editAllocation(allocation, nextAllocation)
        .catch(() => Promise.reject({ allocation, nextAllocation })),
    );
  };
}

export type { Interactor };

export { createInteractor };
